"use strict";
/*
* Created on 26.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var utils_1 = require("../../core/utils");

var SupplierOrderSuggestedHeader_1 = require("../model/SupplierOrderSuggestedHeader");

var SupplierOrderSuggestedHeaderConverter_1 = require("./SupplierOrderSuggestedHeaderConverter");
/**
 * Implementation of {@link SupplierOrderSuggestedHeaderConverter}.
 * @author ZSr
 */


var SupplierOrderSuggestedHeaderConverterImpl =
/*#__PURE__*/
function (_SupplierOrderSuggest) {
  _inherits(SupplierOrderSuggestedHeaderConverterImpl, _SupplierOrderSuggest);

  function SupplierOrderSuggestedHeaderConverterImpl() {
    _classCallCheck(this, SupplierOrderSuggestedHeaderConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierOrderSuggestedHeaderConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierOrderSuggestedHeaderConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SupplierOrderSuggestedHeader_1.SupplierOrderSuggestedHeader(SupplierOrderSuggestedHeader_1.SupplierOrderSuggestedHeader.schema.id.valueOf(conversions.documentToClassId(source)), SupplierOrderSuggestedHeader_1.SupplierOrderSuggestedHeader.schema.externalId.valueOfField(source), SupplierOrderSuggestedHeader_1.SupplierOrderSuggestedHeader.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SupplierOrderSuggestedHeader_1.SupplierOrderSuggestedHeader.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), SupplierOrderSuggestedHeader_1.SupplierOrderSuggestedHeader.schema.dateOfOrder.valueOfField(source), SupplierOrderSuggestedHeader_1.SupplierOrderSuggestedHeader.schema.promotionId.valueOf(utils_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toClassReferenceId(source.promotionId)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        dateOfOrder: conversions.fromDate(source.dateOfOrder),
        promotionId: utils_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toDocumentReferenceId(source.promotionId),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }]);

  return SupplierOrderSuggestedHeaderConverterImpl;
}(SupplierOrderSuggestedHeaderConverter_1.SupplierOrderSuggestedHeaderConverter);

exports.SupplierOrderSuggestedHeaderConverterImpl = SupplierOrderSuggestedHeaderConverterImpl;